import { Route, Routes } from "react-router-dom";
import MainLayout from "../../../../layouts/MainLayout";
import ConsultaBuroSegundoAval from "./ConsultaBuroSegundoAval";
import ExpedienteSegundoAval from "./ExpedienteSegundoAval";
import ExpedienteSegundoAvalCompletado from "./ExpedienteSegundoAvalCompletado";
import InformacionBancariaSegundoAval from "./InformacionBancariaSegundoAval";
import InformacionSegundoAval from "./InformacionSegundoAval";
import InformacionSegundoAvalP2 from "./InformacionSegundoAvalP2";
import RegistroSegundoAval from "./RegistroSegundoAval";
import RegistroSegundoAvalDomicilio from "./RegistroSegundoAvalDomicilio";
import RegistroSegundoAvalRfcCurp from "./RegistroSegundoAvalRfcCurp";
import ValidacionTelefonoSegundoAval from "./ValidacionTelefonoSegundoAval";
import ValidarIndentidadSegundoAval from "./ValidarIndentidadSegundoAval";
import { LoginSegundoAval } from "./LoginSegundoAval";
import { CrearCuentaSegundoAval } from "./CrearCuentaSegundoAval";
import LigaCaducada from "./LigaCaducada";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { TAX_SYSTEM_TYPE_SECONDGUARANTEE } from "@helpers/constantes";
import NotFound from "@pages/NotFound";
import InformacionConyugueSegundoAval from "./InformacionConyugeSegundoAval";
import CambiarContrasenaSegundoAval from "./CambiarContrasenaSegundoAval";
import NuevaContrasenaSegundoAval from "./nuevaContrasena";

export const SegundoAvale = () => {
  const shareholder = useSelector((state: RootState) => state.secondGuarante.guarantee.tax_system_type);
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route path="login" element={<LoginSegundoAval />} />
        <Route path="cambiar_contrasena_aval" element={<CrearCuentaSegundoAval />} />
        {shareholder === TAX_SYSTEM_TYPE_SECONDGUARANTEE.PERSON.code && (
          <>
            <Route path="validacion_telefono_aval" element={<ValidacionTelefonoSegundoAval />} />
            <Route path="registro_aval" element={<RegistroSegundoAval />} />
            <Route path="registro_rfc_curp_aval" element={<RegistroSegundoAvalRfcCurp />} />
            <Route path="registro_domicilio_aval" element={<RegistroSegundoAvalDomicilio />} />
            <Route path="consulta_buro_aval" element={<ConsultaBuroSegundoAval />} />
            <Route path="expediente_digital_segundo_aval" element={<ExpedienteSegundoAval />} />
            <Route path="informacion_aval_1" element={<InformacionSegundoAval />} />
            <Route path="informacion_aval_2" element={<InformacionSegundoAvalP2 />} />
            <Route path="informacion_bancaria_aval" element={<InformacionBancariaSegundoAval />} />
            <Route path="validacion_identidad_aval" element={<ValidarIndentidadSegundoAval type="aval" />} />
            <Route path="validacion_identidad_conyuge" element={<ValidarIndentidadSegundoAval type="conyuge" />} />
            <Route path="expediente_completado_aval" element={<ExpedienteSegundoAvalCompletado />} />
            <Route path="informacion_conyuge_segundo_aval" element={<InformacionConyugueSegundoAval />} />
          </>
        )}
        <Route path="cambiar_contrasena_aval_adicional" element={<CambiarContrasenaSegundoAval />} />
        <Route path="nueva_contraseña_aval_adicional" element={<NuevaContrasenaSegundoAval />} />
        <Route path="liga_caducada" element={<LigaCaducada />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
};
